import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/monthly-overtimes',
    name: 'monthly-overtime',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/monthly-overtime/index.vue')
  }
]
